import classNames from 'classnames';

import {
  formatGoLockerHours,
  getAvailabilityDisplay,
  getGoLockerLocationName,
  getMilesLabel,
} from '../../utils/goLocker';

import styles from './GoLocker.module.scss';

/**
 * GoLockerAvailability — the dot + line under a bank (green / yellow / red / grey).
 * Renders nothing for a location with no availability yet (the card's preview).
 */
export const GoLockerAvailability = ({ availability, className }) => {
  const display = getAvailabilityDisplay(availability);
  if (!display) return null;
  return (
    <div className={classNames(styles.availability, styles[`tone-${display.tone}`], className)}>
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.availabilityText}>{display.label}</span>
    </div>
  );
};

/**
 * GoLockerLocationRow — Figma "GoLocker/Location Item" (12233:3320). Info only,
 * never a radio: any GoLocker works.
 *
 *   "1. GoLocker · 230 Park Ave"  [Indoor]  0.2 mi
 *   Park Ave & E 46th St · building lobby
 *   Daily 6a–11p
 *   ● Open now · M 4 · L 2 · XL 1
 *
 * The Indoor/Outdoor badge renders only if the API ever sends `indoorOutdoor` — it
 * does not today, and the design's badge is not data we have.
 */
const GoLockerLocationRow = ({ location, position }) => {
  const distance = getMilesLabel(location.distance);
  const hours = formatGoLockerHours(location.openingHours);
  const name = getGoLockerLocationName(location);

  return (
    <div className={styles.row}>
      <div className={styles.rowTitle}>
        <span className={styles.rowName}>{position ? `${position}. ${name}` : name}</span>
        {location.indoorOutdoor && (
          <span className={styles.badge}>{location.indoorOutdoor}</span>
        )}
        {distance && <span className={styles.rowDistance}>{distance}</span>}
      </div>
      {location.accessInstructions && (
        <span className={styles.rowMeta}>{location.accessInstructions}</span>
      )}
      {hours && <span className={styles.rowMeta}>{hours}</span>}
      <GoLockerAvailability availability={location.availability} />
    </div>
  );
};

export default GoLockerLocationRow;
